export interface BillingModalInvoiceReceiptFormState {
    realTotalValueKey: number
}
export const initialBillingModalInvoiceReceiptFormState =
    (): BillingModalInvoiceReceiptFormState => ({
        realTotalValueKey: 0
    })
